import { useState } from "react";
import api from "../api";
import { useAuth } from "../AuthContext";
import { useI18n } from "../i18n";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LOGO_URL } from "../brand";
import { ShieldAlert } from "lucide-react";

export default function ForcePasswordChange() {
  const { t } = useI18n();
  const { refreshUser, logout } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) { setError(t("passwordTooShort")); return; }
    if (pw !== pw2) { setError(t("passwordMismatch")); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { new_password: pw });
      toast.success(t("passwordChanged"));
      await refreshUser();
    } catch (err) {
      setError(err.response?.data?.detail || "Error");
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6" data-testid="force-change-page">
      <div className="w-full max-w-sm fade-in">
        <div className="mb-6 flex justify-center"><div className="rounded-lg bg-[#F7F2EA] p-3"><img src={LOGO_URL} alt="Urban Dreams Home" className="h-14 w-auto object-contain" /></div></div>
        <div className="mb-4 flex items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
          <ShieldAlert size={18} /> <span>{t("mustChangeDesc")}</span>
        </div>
        <h1 className="font-head text-2xl font-semibold text-slate-900">{t("mustChangeTitle")}</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div><Label>{t("newPassword")}</Label><Input data-testid="force-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1.5" required /></div>
          <div><Label>{t("confirmPassword")}</Label><Input data-testid="force-password2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="mt-1.5" required /></div>
          {error && <p data-testid="force-error" className="text-sm font-medium text-rose-600">{error}</p>}
          <Button data-testid="force-submit" type="submit" disabled={loading} className="w-full bg-primary hover:bg-primary/90">{loading ? "…" : t("changePassword")}</Button>
        </form>
        <button onClick={logout} className="mt-6 block w-full text-center text-sm text-slate-500 hover:text-primary">{t("logout")}</button>
      </div>
    </div>
  );
}
